import { Collapse as CollapseAnt } from 'antd';
import styled, { css } from 'styled-components';

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 1rem;
`;

export const DescriptionItem = styled.p<{ color?: string }>`
	padding: 0;
	margin: 0 0;
	font-size: 1.2rem;
	display: inline;
	vertical-align: sub;
	color: ${p => p.color || p.theme.text};
`;

export const DescriptionsWrapper = styled.div`
	.ant-descriptions-item-label {
		color: ${({ theme }) => theme.secondary} !important;
		font-size: 16px;
		font-weight: 500;
	}

	.ant-descriptions-item-container {
		p {
			color: ${({ theme }) => theme.textSecondary} !important;
			font-size: 14px;
		}
	}
`;

export const CollapseExpander = styled.div<{ isActive?: boolean }>`
	transition: transform 0.3s;
`;

export const CollapseHeader = styled.div`
	display: flex;
	align-items: center;
	p {
		font-size: 18px;
		font-weight: 500;
		margin-left: 8px;
		color: ${({ theme }) => theme.text};
	}
`;

export const Collapse = styled(CollapseAnt)<{ noPadding?: boolean }>`
	border: none;
	background-color: transparent;

	.ant-collapse-item {
		border-bottom: 1px solid ${({ theme }) => theme.border} !important;
		margin-bottom: 1rem;
		border: 1px solid ${({ theme }) => theme.border};
		border-radius: 10px !important;
		padding: 0 0.5rem;
		box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
	}
	.ant-collapse-header {
		height: 51px !important;
		background-color: ${({ theme }) => theme.white};
		border-radius: 10px 10px 0 0 !important;
		padding: 12px 10px !important;

		p {
			margin: 0 !important;
		}
	}

	.ant-collapse-content-active {
		border-top: 1px solid ${({ theme }) => theme.borderLight} !important;
	}

	.ant-collapse-content-inactive {
		border-top: 1px solid ${({ theme }) => theme.borderLight} !important;
	}

	.ant-collapse-content-box {
		padding: 10px 10px !important;
	}

	${p =>
		p.noPadding &&
		css`
			.ant-collapse-content-box {
				padding: 0px !important;
			}
		`}
`;
